import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import useCurrentPage from '../../../hooks/useCurrentPage';
import useMapPinSecondaryLabel from '../../../hooks/useMapPinSecondaryLabel';
import styles from './styles.scss';

const propTypes = {
  index: PropTypes.number,
};

const defaultProps = {
  index: undefined,
};

const FacilitiesLegendItemMarker = ({ index }) => {
  const { secondaryColorClass, secondaryColorBackgroundClass } = useCurrentPage();
  const [text, fontFamilyClass] = useMapPinSecondaryLabel(index);

  const classes = cx(
    styles.marker,
    text && secondaryColorClass,
    !text && secondaryColorBackgroundClass,
    !text && styles.circle,
    fontFamilyClass,
  );

  return (
    <div
      className={classes}
      data-testid="facilities-legend-item-marker"
    >
      {text}
    </div>
  );
};

FacilitiesLegendItemMarker.propTypes = propTypes;
FacilitiesLegendItemMarker.defaultProps = defaultProps;

export default FacilitiesLegendItemMarker;
